import React from 'react';
import { Link } from 'react-router-dom';
import { MOMENT_ICONS, VHU_LOGO, APP_NAME } from '../utils/iconMappings';
import '../styles/components/LeftMenu.css'; // Ensure you have styles for the left menu

const LeftMenu: React.FC = () => {
  return (
    <nav className="left-menu">
      <div className="logo">
        <img src={VHU_LOGO} alt="vHearU Logo" className="icon" />
        <h1>{APP_NAME}</h1>
      </div>
      <ul className="menu-items">
        <li className="menu-item">
          <span className="icon material-symbols-outlined">dashboard</span>
          <span className="text">Dashboard</span>
        </li>
        <li className="menu-item">
          <span className="icon material-symbols-outlined">compare</span>
          <span className="text">Comparisons</span>
        </li>
        <li className="menu-item">
          <span className="icon material-symbols-outlined">people</span>
          <span className="text">Agents</span>
        </li>
        <li className="menu-item active">
          <Link to="/interactions" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <span className="icon material-symbols-outlined">chat</span>
            <span className="text">Interactions</span>
          </Link>
        </li>
        <li className="menu-item active">
          <Link to="/moments" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <span className="icon material-symbols-outlined">{MOMENT_ICONS.MENU}</span>
            <span className="text">Moments</span>
          </Link>
        </li>
        <li className="menu-item">
          <Link to="/utterances" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <span className="icon material-symbols-outlined">library_books</span>
            <span className="text">Utterances</span>
          </Link>
        </li>
        <li className="menu-item">
          <Link to="/metadata" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <span className="icon material-symbols-outlined">dataset</span>
            <span className="text">Metadata</span>
          </Link>
        </li>
        <li className="menu-item">
          <Link to="/live-assist" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <span className="icon material-symbols-outlined">assistant</span>
            <span className="text">Live Assist</span>
          </Link>
        </li>
        <li className="menu-item">
          <span className="icon material-symbols-outlined">assessment</span>
          <span className="text">Reports</span>
        </li>
      </ul>
    </nav>
  );
};

export default LeftMenu;